import React, { useState, useContext, useEffect, useCallback } from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AppContext } from './AppContext'; 

import './_css/vars.css';
import './_css/reset.css';
import './_css/App.css';

import THEMES from './_data/THEMES.js';

import Editor from "./_views/Editor.js";
import List from "./_views/List.js";

function App() {
	const [themes, setThemes] = useState();
	
	useEffect(() => {
		const fetchData = async () => {
		  	const data = await THEMES;
			data.sort((a,b) => a.id - b.id);
	    	setThemes(data);
	  	}
	  	fetchData().catch(console.error);;
	}, [])
	if (themes === undefined) return <div class="App"><h1>Setting the scene...</h1></div>;
	return (
		<div class="App">	 
			<AppContext.Provider
				value={{
					themes
				}}>
				{ themes &&
					<BrowserRouter>
						<Routes>
							<Route path="/" element={<List />} />
							<Route path="/editor/:themeID/:templateID" element={<Editor />} />
						</Routes>
					</BrowserRouter>
				}
			</AppContext.Provider>
		</div>
	);
}

export default App;
